/**
 * WP Swiper Plugin - Hover Flip Card Mobile Toggle
 * Version: 1.0.0
 */

(function($) {
    'use strict';
    
    var WPHoverFlipCard = {
        
        init: function() {
            $(window).on('elementor/frontend/init', this.onElementorFrontendInit.bind(this));
            
            if (typeof elementorFrontend === 'undefined') {
                $(document).ready(this.initCards.bind(this));
            }
        },
        
        onElementorFrontendInit: function() {
            elementorFrontend.hooks.addAction('frontend/element_ready/hover_flip_card.default', this.initWidget.bind(this));
        },
        
        initWidget: function($scope) {
            var $card = $scope.find('.hover-flip-card');
            if ($card.length) {
                this.bindToggle($card);
            }
        },
        
        initCards: function() {
            $('.hover-flip-card').each(function() {
                WPHoverFlipCard.bindToggle($(this));
            });
        },
        
        bindToggle: function($card) {
            var $afterBtn = $card.find('.hover-flip-card__toggle-btn--after');
            var $beforeBtn = $card.find('.hover-flip-card__toggle-btn--before');
            
            // See After 按钮
            $afterBtn.on('click', function(e) {
                e.preventDefault();
                $card.addClass('is-flipped');
                $afterBtn.hide();
                $beforeBtn.show();
            });
            
            // See Before 按钮
            $beforeBtn.on('click', function(e) {
                e.preventDefault();
                $card.removeClass('is-flipped');
                $beforeBtn.hide();
                $afterBtn.show();
            });
        }
    };
    
    WPHoverFlipCard.init();
    
    window.WPHoverFlipCard = WPHoverFlipCard;
    
})(jQuery);
